import * as ReactGA from "react-ga";
import { LOCATION_CHANGE } from "react-router-redux";
import { Action, Dispatch, Middleware, MiddlewareAPI } from "redux";
import { Constants as AuthConstants } from "../actions/AuthActions";
import { LocationChangeProps } from "../actions/RouterActions";

export const GoogleAnalyticsMiddleware: Middleware =
    (api: MiddlewareAPI<void>) =>
    (next: Dispatch<void>) =>
    <A extends Action>(action: A) => {

    if (action.type === LOCATION_CHANGE) {
        if ((action as any).payload) {
            // on path changed
            const props = (action as any).payload as LocationChangeProps;
            ReactGA.pageview(props.pathname + (props.search || "") + (props.hash || ""));
        }
    }

    else if (action.type === AuthConstants.USERGUID_CHANGED) {
        // on user guid changed
        const userId = (action as any).payload as string | undefined;
        ReactGA.set({ userId });
    }

    return next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/GoogleAnalyticsMiddleware.ts